export default __webpack_public_path__ + "static/media/587.8125ccb8.png";